var _style, _path, _path2, _path3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380.7 144",
    style: {
      enableBackground: "new 0 0 380.7 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.logo0{fill:#182744;}\n\t.logo1{fill:url(#SVGID_1_);}\n\t.logo2{fill:url(#SVGID_2_);}\n\t.logo3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo0",
    d: "M170.1,108c0-3.5,1.1-6.8,3.2-9.6c-4.4,6-4.2,14.2,0.5,20C171.3,115.4,170.1,111.7,170.1,108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9967,
    y1: 12.265,
    x2: 132.0511,
    y2: 143.044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFBA5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7640"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo1",
    d: "M131.9,32v41.3h0c0.3,11.8-6.7,22.6-17.6,27.1c-10.9,5.5-24,3.4-32.6-5.2c-4.7-4.8-9-10.1-12.7-15.7 c-4.1-5.5-7.6-11.4-11.8-16.8c-3.6-4.9-9.5-7.7-15.6-7.5c-10,0.3-17.8,8.7-17.5,18.6c0.2,5.1,2.5,10,6.4,13.3 c5.8,4.9,14.2,5.5,20.6,1.4c3-2.4,5.8-5,8.4-7.8c0.6-0.7,1.2-1.4,1.8-2.1l6.9,10.6c-6.9,10.2-19,15.5-31.1,13.6 c-4.9-0.8-9.5-2.9-13.3-6v46.6l7.7-11.9C43.4,139.7,57.5,144,72,144c39.8,0,72-30.6,72-70.4C144,58.9,139.8,44.4,131.9,32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8676,
    y1: 2.5998,
    x2: 141.922,
    y2: 133.3787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFBA5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7640"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logo2",
    d: "M62.4,51.3c4.6,4.8,8.8,10,12.5,15.5c3.6,4.9,6.6,10.2,10.2,15.1c4.1,5.5,9.2,9.4,16.5,9.4 c10,0.1,18.1-7.9,18.2-17.9c0-5.4-2.3-10.5-6.5-14c-6-4.9-14.5-5.4-21.1-1.3c-1.8,1.2-3.5,2.7-5.1,4.3c-1.6,1.6-2.9,3.4-4.5,5.4 c-2.4-3.5-4.8-6.9-7.1-10.2c9.6-12.9,22.5-16.3,35-12.9c3.4,1,6.7,2.5,9.5,4.7V0l-6.5,13.3c-32.4-23-77.4-15.4-100.4,17 C-4,54.6-4.5,87.1,12.1,112V70.7h0.1c0.8-9.6,6.3-18.2,14.6-23.1C38.2,40.6,52.8,42.2,62.4,51.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M175.8,95.6c2.1-1.8,4.7-3,7.5-3.5C180.5,92.6,177.9,93.8,175.8,95.6z M175.3,120c2.7,2.5,6.2,4,9.9,4.2 C181.5,124,178,122.5,175.3,120z M185.2,124.2c0.2,0,0.4,0,0.7,0h0.2C185.8,124.2,185.5,124.2,185.2,124.2L185.2,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M197,81.2v14.9c-2.8-2.6-6.3-4.1-10.1-4.2c-0.3,0-0.6,0-0.9,0H186c-0.2,0-0.5,0-0.7,0c-0.3,0-0.5,0-0.8,0.1 c-0.4,0-0.9,0.1-1.3,0.2c-2.8,0.5-5.3,1.7-7.5,3.5c-0.2,0.1-0.3,0.3-0.5,0.4c-0.2,0.2-0.4,0.3-0.5,0.5c-0.2,0.2-0.4,0.4-0.5,0.6 c-0.3,0.4-0.7,0.8-1,1.2c-2.1,2.8-3.2,6.2-3.2,9.6c0,3.8,1.3,7.4,3.6,10.3c0.2,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.4,0.4,0.5,0.6 c0.2,0.2,0.4,0.4,0.6,0.5c2.7,2.5,6.2,4,9.9,4.2c0.3,0,0.5,0,0.8,0c0.2,0,0.4,0,0.6,0c4-0.3,7.7-2.1,10.6-4.9 c3.1-2.9,4.8-7,4.6-11.3V81.2H197z M186.3,119.3c-6.1-0.1-11-5.1-10.9-11.3c0.2-6,5.2-10.8,11.3-10.6c6,0.2,10.8,5.2,10.6,11.3 C197.1,114.7,192.2,119.4,186.3,119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M223.8,91.8c-9-0.1-16.3,7.1-16.4,16.1c-0.1,9,7.1,16.3,16.1,16.4c9,0.1,16.3-7.1,16.4-16.1c0,0,0,0,0-0.1 c0.2-8.8-6.9-16.1-15.7-16.3C224,91.8,223.9,91.8,223.8,91.8z M223.8,119.2c-5.9,0.1-10.7-4.6-10.8-10.5c0-0.2,0-0.3,0-0.5 c-0.1-6.1,4.7-11.1,10.8-11.3c6,0.2,10.8,5.2,10.8,11.3c0.1,5.9-4.6,10.9-10.5,11C223.9,119.2,223.9,119.2,223.8,119.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M280.6,91.8c-4.4,0.1-8.4,2.4-10.7,6.2c-1.5-3.9-5.3-6.3-9.5-6.2c-3.6,0-7.1,1.6-9.4,4.4v-3.7h-5.2v30.9h5.2 v-13.2c-0.4-3.6,0.4-7.2,2.3-10.2c1.5-2,3.8-3.1,6.3-3.2c3.1-0.2,5.7,2.2,5.9,5.3c0,0.5,0.1,1,0.1,1.5c0.1,1.1,0.2,2.4,0.2,3.9 v15.8h5.2v-13.6c-0.1-2.5,0.2-5,1-7.4c1.2-3.3,4.2-5.5,7.7-5.5c2.9-0.2,5.5,1.9,5.9,4.8c0,0.4,0.1,0.8,0.1,1.3 c0.1,1.2,0.2,2.4,0.2,3.6v16.8h5.2v-18.2C291.3,96.9,287.3,91.8,280.6,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M324.6,92.6v4.1c-2.8-3.1-6.8-4.9-11-4.8c-8.9,0.2-16.1,7.5-15.9,16.5c0.2,8.7,7.1,15.7,15.8,15.9 c4.2,0,8.2-1.6,11.2-4.6v3.9h5.1V92.6H324.6z M313.9,119.3c-6.1-0.1-11-5.1-10.9-11.3c0.2-6,5.2-10.8,11.3-10.6 c6,0.2,10.8,5.2,10.6,11.3C324.8,114.6,319.9,119.4,313.9,119.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.2,
    y: 92.6,
    className: "logo3",
    width: 5.2,
    height: 30.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M341.7,80.5c-2.1,0-3.8,1.8-3.8,3.9c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.9-1.7,3.9-3.9 C345.6,82.2,343.8,80.5,341.7,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M369.1,91.8c-4,0-7.7,1.8-10.3,4.8v-4h-5.2v30.9h5.2v-13.1c0-4.6,0.4-7.3,2.4-10c1.6-2.3,4.3-3.7,7.2-3.7 c4.9,0,7.2,3.1,7.2,10v16.7h5.2v-17.2C380.7,97.2,376.3,91.8,369.1,91.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M203.2,44.1c0-0.3-0.1-0.5-0.1-0.8c0,0,0-0.1,0-0.1c-0.1-0.2-0.1-0.5-0.2-0.7c-0.2-0.7-0.4-1.4-0.7-2.1 c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.4-0.4-0.7c-0.5-0.9-1.1-1.7-1.8-2.5c-0.2-0.2-0.3-0.4-0.5-0.5 c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2-0.2-0.4-0.3-0.6-0.5c-0.6-0.5-1.2-0.9-1.8-1.3c-0.2-0.1-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.2-0.7-0.3 c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.1-0.6-0.2 c-1.3-0.4-2.7-0.5-4-0.5c-0.8,0-1.7,0.1-2.5,0.2c-3.7,0.6-7.1,2.6-9.5,5.6c-2.2,2.7-3.5,6-3.7,9.4v26.3h3.8v-16 c4.3,5.4,11.7,7.3,18,4.6c0.2-0.1,0.3-0.1,0.5-0.2c5-2.4,8.3-7.4,8.8-12.9c0-0.2,0-0.4,0-0.5c0-0.3,0-0.6,0-0.8 C203.4,45.7,203.3,44.9,203.2,44.1z M187.6,58.7c-6.7-0.1-12-5.7-11.8-12.3c0.1-6.5,5.4-11.7,11.8-11.8c6.5,0,11.8,5.3,11.8,11.9 c0,0,0,0.1,0,0.1C199.5,53.2,194.2,58.6,187.6,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M235.5,31.6v5.5c-2.7-4-7.1-6.3-11.9-6.2C215,31,208,38.1,208.2,46.7c0.1,8.4,6.9,15.3,15.4,15.5 c4.7,0,9.1-2.1,12-5.8v5.1h3.8V31.6H235.5z M223.9,58.7c-6.6-0.1-11.8-5.6-11.7-12.1c0.2-6.5,5.6-11.7,12.1-11.5 s11.7,5.6,11.5,12.1C235.6,53.6,230.4,58.8,223.9,58.7L223.9,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M259.5,30.8c-3.3,0.3-6.2,2.2-7.7,5.1v-4.3h-4v29.8h4V50.1c-0.1-3,0.1-6.1,0.6-9c1.1-4.1,3.6-6.5,6.5-6.5 c0.7,0,1.4,0.2,2,0.6l2-3.3C261.9,31.2,260.7,30.8,259.5,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M292,31.6v5.5c-2.7-4-7.1-6.3-11.9-6.2c-8.7,0.1-15.6,7.2-15.5,15.9c0.1,8.4,6.9,15.3,15.4,15.5 c4.7,0,9.1-2.1,12-5.8v5.1h3.8V31.6H292z M280.3,58.7c-6.6-0.1-11.8-5.6-11.7-12.1c0.2-6.5,5.6-11.7,12.1-11.5 c6.5,0.2,11.7,5.6,11.5,12.1C292.1,53.6,286.8,58.8,280.3,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M306.6,20.1v41.4h3.8V20.1H306.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M323.5,20.1v41.4h3.8V20.1H323.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M351.9,58.7c-6.3-0.1-11.3-5.2-11.2-11.5c0-0.1,0-0.3,0-0.4h26.9c0.4-8.4-6-15.6-14.4-16c-0.4,0-0.7,0-1.1,0 c-8.5,0-15.4,6.9-15.4,15.4c0,0.1,0,0.3,0,0.4C336.5,55,343,62,351.4,62.2c0.3,0,0.6,0,0.9,0c6.1,0.2,11.8-3.3,14.2-8.9l-3.2-1.7 C361.2,56,356.7,58.8,351.9,58.7z M352.1,34.5c5.4-0.2,10.2,3.6,11.2,8.9H341C342,38.2,346.7,34.4,352.1,34.5L352.1,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo3",
    d: "M376.9,20.1v41.4h3.8V20.1H376.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.272e22948efaa48b0ea9cf94c90b7bd7.svg";
export { ForwardRef as ReactComponent };